import type { ActiveKidSkillSnapshot, KidSkillsState } from '../types/kidSkill.js';
import type { KidSkillId } from '../types/kidSkill.js';

export async function fetchKidSkillsState(): Promise<KidSkillsState> {
  const res = await fetch('/api/family/child/kid-skills', { credentials: 'include' });
  if (!res.ok) {
    throw new Error('Failed to load kid skills');
  }
  return (await res.json()) as KidSkillsState;
}

export async function setDailyKidSkill(skillId: KidSkillId): Promise<ActiveKidSkillSnapshot | null> {
  const res = await fetch('/api/family/child/kid-skills/daily', {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ skillId }),
  });
  if (!res.ok) {
    throw new Error('Failed to set daily kid skill');
  }
  const body = (await res.json()) as { activeKidSkill: ActiveKidSkillSnapshot | null };
  return body.activeKidSkill;
}
